export const animationSettings = {
  'book-anim': {
    'default': ['static'],
    'SCATTER:START': ['play', false, '2book-react-on-scatter', { name: 'TRANSITION-BONUS-ANIM:DONE', delay: 2 }],
    'STATE:IN:FS-START': ['play', false, '4show-bonus-game'],
    'STATE:OUT:FS-START': ['play', false, '5page-flies-away-reels-appear', { name: 'START-FS-REEL-ANIMATION', delay: 0.1 }],
    'START-FS-REEL-ANIMATION': ['static'],
    'STATE:IN:BET': ['play', true, '1book-idle'],
  },

  'add-fs': {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', true, '1book-idle', { name: 'DONE', delay: 1 }],
    'DONE': ['play', false, '3book-fly-and-flip-pages'],
  },

  'book-reel': {
    'default': ['static'],
    'START-FS-REEL-ANIMATION': ['play', false, '5page-flies-away-reels-appear', { name: 'START-REEL-IDLE', delay: 0.1 }],
    'START-REEL-IDLE': ['play', true, '6reels-idle'],
    'STATE:IN:FS-END': ['play', false, '7reels-out'],
  },

  'fs-end': {
    'default': ['play', true, 'loop-end'],
    'STATE:IN:FS-END': ['play', false, 'start-end', { name: 'LOOP-END-FS', delay: 3 }],
    'LOOP-END-FS': ['play', true, 'loop-end'],
  },
}
